import { type SectionType, type TermType } from "components/server-types";
import { isLinkedSection, isTemplateSection } from "utils/publishing";

/**
 * A section is considered archived if it, its term, or (for linked sections) its template section
 * is archived. Shared by the `useIsArchived` hook and the `selectCurrentSectionIsArchived` selector.
 *
 * @param terms terms list (e.g. from `termSelectors.selectAll`).
 * @param sections sections to search for the linked section's template (template sections, or all
 *   sections — ids are unique so either works).
 */
export const isSectionArchived = (
  section: Pick<SectionType, "kind" | "term_id" | "template_id" | "archived_at"> | null | undefined,
  terms: Pick<TermType, "id" | "archived_at">[],
  sections: Pick<SectionType, "id" | "kind" | "archived_at">[],
): boolean => {
  if (!section) return false;
  const term = terms.find((t) => t.id === section.term_id);
  const templateSection = isLinkedSection(section)
    ? sections.find((s) => isTemplateSection(s) && s.id === section.template_id)
    : undefined;

  return Boolean(section.archived_at || term?.archived_at || templateSection?.archived_at);
};
